import { render, staticRenderFns } from "./EnvironmentalSolution.vue?vue&type=template&id=1fc54caa&scoped=true&"
import script from "./EnvironmentalSolution.vue?vue&type=script&lang=js&"
export * from "./EnvironmentalSolution.vue?vue&type=script&lang=js&"
import style0 from "./EnvironmentalSolution.vue?vue&type=style&index=0&id=1fc54caa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc54caa",
  null
  
)

export default component.exports